module.exports = __webpack_public_path__ + "img/bg_customer.cb34aa0c.png";